module.exports = __webpack_public_path__ + "img/more-images-active.74b7532a.svg";